import { render, staticRenderFns } from "./FileUploadOssPics.vue?vue&type=template&id=dac644e4&scoped=true"
import script from "./FileUploadOssPics.vue?vue&type=script&lang=js"
export * from "./FileUploadOssPics.vue?vue&type=script&lang=js"
import style1 from "./FileUploadOssPics.vue?vue&type=style&index=1&id=dac644e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac644e4",
  null
  
)

export default component.exports